"use client";

import { useCreation } from "ahooks";

// eslint-disable-next-line @typescript-eslint/promise-function-async
function _OnlyClient({
  callback,
  children,
}: {
  callback?: () => any;
  children?: React.ReactNode;
}) {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useCreation(() => callback?.(), []);

  return children;
}

export const OnlyClient: typeof _OnlyClient =
  typeof window === "undefined" ? () => null : _OnlyClient;
